import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Form, TextArea } from 'semantic-ui-react';

import { SummaryEditor } from '../../components';

const moments = date => moment(new Date(date)).format('DD/MM/YYYY hh:mm:ss a');

class SmallBrandSentenceEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
    };
  }

  navigateTo = (route) => {
    switch (route) {
      case 'brandPage':
        this.props.history.push(`/brandLanding/${this.brandId}`);
        break;
      case 'ratingPage':
        this.props.history.push(`/env-standards-compliance/${this.brandId}`);
        break;
      case 'next': 
        this.props.history.push(`/brandLanding/${this.brandId}`)
      default:
    }
  }

  toggleEdit = () => {
    this.setState({ isEditing: !this.state.isEditing });
  }

  handleSave = (newSentence) => {
    this.props.onSave(newSentence)
    this.toggleEdit();
  }

  handleSaveAndNext = (newSentence) => {
    this.handleSave(newSentence);
    this.navigateTo('next');
  }

  handleCancel = () => {
    this.props.onCancel();
    this.toggleEdit();
  }

  render = () => {
    let sentence = this.props.sentence
    return (
      <div>
        <h5>What is the one sentence that describes the brand best?</h5>
        <Form>
          <TextArea rows={8} readOnly value={sentence.text} />
          <p>Updated At: <strong>{moments(sentence.updatedAt)}</strong></p>
        </Form>

        {this.state.isEditing
          ? <SummaryEditor
            originalText={sentence.text || ''}
            onSave={(newSentence) => this.handleSave(newSentence)}
            onSaveAndNext={(newSentence) => this.handleSaveAndNext(newSentence)}
            onCancel={() => this.handleCancel()}
          />
          :(
            <div className='button-block'>
              <button onClick={() => { this.toggleEdit(); }}>Edit Current Sentence</button>
            </div>
          )
        }
      </div>
    )
  }
}

SmallBrandSentenceEditor.propTypes = {
  sentence: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default SmallBrandSentenceEditor;


// WEBPACK FOOTER //
// ./src/components/Sentences/SmallBrandSentenceEditor.js